import { useAuthStore } from '@/stores/authStore';

/**
 * Whether the current member may expose and use armed one-click placement.
 * The relay resolves this from traderRules.oneClickEnabled and enforces it on
 * every app-tagged one-click order. This hook is presentation gating only.
 */
export function useOneClickAccess(): boolean {
  return useAuthStore((s) => s.user?.oneClickAccess ?? false);
}
